import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const TIMEZONE_SERVER = 'Europe/Berlin';
dayjs.tz.setDefault(TIMEZONE_SERVER);

export const getDayjsByUnix = (timestamp, timezone = TIMEZONE_SERVER) => {
  return dayjs.tz(timestamp * 1000, timezone);
};

export const getDayjsByDate = (date, timezone = TIMEZONE_SERVER) => {
  return dayjs.tz(date, timezone);
};
